/**
 * The stock take moved to its own API app: `/apps/assets/api/v1/audits/`.
 *
 * An audit is now an exercise with a checklist, not a bag of scanned rows, so
 * these are the exercise (list/create/delete), its items, and the three things
 * you do to it — scan, complete, reconcile.
 */
export default {
  GET_AUDIT_RECORDS: ({ page = 1, rowsPerPage = 10, locationId = '', auditStatus = '' }) =>
    `audits/?page=${page}&page_size=${rowsPerPage}&location_id=${locationId}&status=${auditStatus}`,
  // Audits covering one asset — used by the asset detail page's Audit tab.
  GET_ASSET_AUDIT_RECORDS: ({ id, page = 1, rowsPerPage = 10 }) =>
    `audits/?asset_id=${id}&page=${page}&page_size=${rowsPerPage}`,
  GET_AUDIT_RECORD: (id) => `audits/${id}/`,
  GET_AUDIT_ITEMS: ({ id, page = 1, rowsPerPage = 10, itemStatus = '' }) =>
    `audits/${id}/items/?page=${page}&page_size=${rowsPerPage}&status=${itemStatus}`,
  CREATE_AUDIT_RECORD: 'audits/',
  DELETE_AUDIT_RECORD: (id) => `audits/${id}/`,
  // One scan. The server resolves the barcode against the checklist, so the
  // client no longer has to hold every asset in the branch in memory.
  SCAN_AUDIT_ITEM: (id) => `audits/${id}/scan/`,
  COMPLETE_AUDIT: (id) => `audits/${id}/complete/`,
  RECONCILE_AUDIT_RECORD: (id) => `audits/${id}/reconcile/`,
};
